const formatter = new Intl.RelativeTimeFormat('ru', {numeric: 'auto'});

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** «только что», «5 минут назад», «вчера», «3 недели назад»: чем старше дата, тем крупнее единица */
export function ago(date: Date | number, now: number = Date.now()): string {
	const diff = now - new Date(date).getTime();
	if (diff < MINUTE) return 'только что';
	if (diff < HOUR) return formatter.format(-Math.floor(diff / MINUTE), 'minute');
	if (diff < DAY) return formatter.format(-Math.floor(diff / HOUR), 'hour');
	if (diff < 7 * DAY) return formatter.format(-Math.floor(diff / DAY), 'day');
	if (diff < 30 * DAY) return formatter.format(-Math.floor(diff / (7 * DAY)), 'week');
	if (diff < 365 * DAY) return formatter.format(-Math.floor(diff / (30 * DAY)), 'month');
	return formatter.format(-Math.floor(diff / (365 * DAY)), 'year');
}
